import type {
  AdminCapabilities,
  AdminInvitationStatus,
  AdminRole,
} from "../types/auth";

export function normalizeEmail(value: string): string {
  return value.trim().toLowerCase();
}

export function toDate(value: unknown): Date | null {
  if (
    typeof value === "object" &&
    value !== null &&
    "toDate" in value &&
    typeof value.toDate === "function"
  ) {
    const nextDate = value.toDate();
    return nextDate instanceof Date ? nextDate : null;
  }

  return null;
}

export function asRecord(value: unknown): Record<string, unknown> {
  return typeof value === "object" && value !== null
    ? (value as Record<string, unknown>)
    : {};
}

export function normalizeAdminRole(value: unknown): AdminRole {
  if (
    value === "global_admin" ||
    value === "formation_admin" ||
    value === "trainer"
  ) {
    return value;
  }

  return "formation_admin";
}

export function normalizeInvitationStatus(
  value: unknown,
): AdminInvitationStatus {
  if (value === "accepted" || value === "revoked") {
    return value;
  }

  return "pending";
}

export function normalizeCapabilities(value: unknown): AdminCapabilities {
  const data = asRecord(value);

  return {
    canCreateFormation: data.canCreateFormation === true,
    canCreateSession: data.canCreateSession === true,
    canInviteAdmin: data.canInviteAdmin === true,
    canManageAdmins: data.canManageAdmins === true,
  };
}

export function defaultCapabilitiesForRole(role: AdminRole): AdminCapabilities {
  if (role === "global_admin") {
    return {
      canCreateFormation: true,
      canCreateSession: true,
      canInviteAdmin: true,
      canManageAdmins: true,
    };
  }

  if (role === "formation_admin") {
    return {
      canCreateFormation: true,
      canCreateSession: true,
      canInviteAdmin: false,
      canManageAdmins: false,
    };
  }

  return {
    canCreateFormation: false,
    canCreateSession: false,
    canInviteAdmin: false,
    canManageAdmins: false,
  };
}
